<template>
  <div>
    <AppHeader />
    <div class="container">
      <v-btn class="ma-2" :loading="loading" @click="generaTurnos" size="x-large" dark>
        Generar Turnos
        <template v-slot:loader>
          <v-progress-linear indeterminate></v-progress-linear>
        </template>
      </v-btn>
      <!-- Botón para exportar a Excel -->
      <v-btn class="ma-2" @click="exportToExcel" color="success">Exportar a Excel</v-btn>
      <!-- Botón para exportar codos a pdf -->
      <v-btn class="ma-2" @click="exportToPDF" color="info">Exportar codos turnos</v-btn>
      <br />
      <v-overlay :value="loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-overlay>
      <AppTable :Turnos="ListaTurnos" ref="tableComponent" />
      <!-- Dialog de sesión expirada -->
      <v-dialog v-model="showSessionExpiredDialog" max-width="400">
        <v-card>
          <v-card-title>¡Sesión expirada!</v-card-title>
          <v-card-text>Tu sesión ha expirado. Por favor, inicia sesión nuevamente.</v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="redirectToLogin">Iniciar sesión</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/HeaderC.vue";
import AppTable from "@/components/TableTurnosC.vue";
import axios from "axios";
import { utils as XLSXUtils, writeFile as writeExcel } from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "TurnosView",
  data() {
    return {
      showSessionExpiredDialog: false,
      ListaTurnos: [],
      loading: false,
      validToken: false,
    };
  },
  components: {
    AppHeader,
    AppTable,
  },
  mounted: function () {
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.validateToken();
      await this.obtieneRegistros();
    },
    // async exportToPDF() {
    //   const doc = new jsPDF;
    //   let y = 10
    //   const marginBottom = 10;
    //   const pageHeight = doc.internal.pageSize.height;

    //   doc.setFontSize(10); // Reducir tamaño de letra

    //   this.loading = true;

    //   this.ListaTurnos.forEach((item) => {
    //     // if (index !== 0) y += 20;
    //     if (y + 30 > pageHeight - marginBottom) {
    //       doc.addPage();
    //       y = 10;
    //     }

    //     doc.setFont("helvetica", "normal");//Normal
    //     doc.text(`Nombre: ${item.Nombre_Cargador}`, 10, y);
    //     doc.text(`CUI: ${item.Documento_Identificacion}`, 100, y);
    //     doc.text(`Turno: ${item.Numero_Turno}`, 10, y + 5);
    //     doc.text(`Brazo: ${item.Numero_Brazo}`, 100, y + 5);
    //     doc.setFont("helvetica", "bold"); //Negrita
    //     doc.text(`Recibo No: ${item.No_Recibo}`, 10, y + 10);
    //     doc.text(`Mesa: ${item.Mesa}`, 100, y + 10);

    //     doc.line(10, y + 15, 200, y + 15); // Línea separadora

    //     y += 20;//Aumenta la posición para el siguiente registro
    //   });

    //   doc.save("Codos-Turnos.pdf")
    //   this.loading = false;
    // },
    async exportToPDF() {
      const doc = new jsPDF({
        orientation: "p", // Vertical
        unit: "mm",
        format: [142, 210] // Tamaño en mm (14.2 cm x 21 cm)
      });

      // Configuración de los stickers
      const stickerWidth = 64; // 6.4 cm = 64 mm
      const stickerHeight = 32; // 3.2 cm = 32 mm
      const marginLeft = 4; // Margen izquierdo
      const marginTop = 1; // Margen superior
      const columnSpacing = 6; // Espacio entre columnas
      const rowSpacing = 3; // Espacio entre filas
      const columns = 2;
      const rows = 6;
      const lineHeight = 5; // Espaciado entre líneas
      // const maxTextWidth = stickerWidth - 4; // Espacio útil dentro del sticker
      const maxChars = 25; // Número máximo de caracteres por línea (aproximado)

      let currentIndex = 0;
      this.loading = true;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10); // Tamaño de fuente ajustado

      this.ListaTurnos.forEach((item) => {
        if (currentIndex >= columns * rows) {
          doc.addPage();
          currentIndex = 0;
        }

        // Calcular la posición del sticker
        const col = currentIndex % columns;
        const row = Math.floor(currentIndex / columns);
        const x = marginLeft + col * (stickerWidth + columnSpacing);
        const y = marginTop + row * (stickerHeight + rowSpacing);

        // Datos a imprimir (recortados horizontalmente si son muy largos)
        const truncateText = (text) => text.length > maxChars ? text.substring(0, maxChars - 3) + "..." : text;

        const textLines = [
          `Nombre: ${truncateText(item.Nombre_Cargador)}`,
          `CUI: ${truncateText(item.Documento_Identificacion)}`,
          `Turno: ${truncateText(item.Numero_Turno)}`,
          `Brazo: ${truncateText(item.Numero_Brazo)}`,
          `Recibo No: ${truncateText(item.No_Recibo)}`,
          `Mesa: ${truncateText(item.Mesa)}`
        ];

        let textY = y + 5;

        textLines.forEach((text) => {
          doc.text(text, x, textY);
          textY += lineHeight;
        });

        currentIndex++; // Pasar al siguiente sticker
      });

      doc.save("Stickers-Turnos.pdf");
      this.loading = false;
    },



    redirectToLogin() {
      // localStorage.removeItem('token');
      // localStorage.removeItem('user');
      // localStorage.removeItem('username');
      // localStorage.removeItem('name');

      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) {
        this.$cookies.remove(cookie);
      }
      // Redirigir al usuario al componente de inicio de sesión
      this.$router.push("/");
    },
    async generaTurnos() {
      await this.validateToken();
      this.loading = true;
      const apiUrl = "https://pc61cf7yyj.execute-api.us-east-1.amazonaws.com/dev/api/turnos";

      // Configuración para la solicitud GET con el token en el encabezado Authorization
      const config = {
        headers: {
          Authorization: `Bearer ${this.$cookies.get("token")}`,
        },
      };
      const proc = this.$cookies.get("ProcesionID");
      const bodyReq = {
        idProcesion: proc,
        usuarioResponsable: this.$cookies.get("username"),
      };

      axios
        .post(apiUrl, bodyReq, config)
        .then(() => {
          this.obtieneRegistros();
          this.loading = false; // Desactivar animación de carga
        })
        .catch(() => {
          // console.error('Error al obtener datos de la API', error);
          this.loading = false; // Desactivar animación de carga en caso de error
        });
    },
    validateToken() {
      // const token = localStorage.token
      const token = this.$cookies.get("token");
      this.loading = true;
      const apiUrl = `https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev/validateToken?token=${token}`;
      // Configuración para la solicitud GET con el token en el encabezado Authorization
      // Realizar solicitud GET a la API original con el token en el encabezado
      return axios
        .get(apiUrl)
        .then((response) => {
          const username = response.data.decoded.username;

          this.$cookies.set("username", username, "1d", "", "", true, "Strict");

          // localStorage.username = response.data.decoded.username;
          this.validToken = true;
          this.loading = false; // Desactivar animación de carga
        })
        .catch(() => {
          this.validToken = false;
          this.showSessionExpiredDialog = true;
          // console.error(error)
          // console.error('Error al obtener datos de la API', error);
          this.loading = false; // Desactivar animación de carga en caso de error
          // localStorage.clear
          this.clearAllCookies();
          // this.$router.push('/');
        });
    },
    clearAllCookies() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) {
        this.$cookies.remove(cookie);
      }
    },
    async obtieneRegistros() {
      await this.validateToken();
      this.loading = true;
      const token = this.$cookies.get("token");
      const proc = this.$cookies.get("ProcesionID");
      const apiUrl = `https://pc61cf7yyj.execute-api.us-east-1.amazonaws.com/dev/api/turnos/${proc}?usuarioResponsable=${this.$cookies.get("username")}`;
      // Configuración para la solicitud GET con el token en el encabezado Authorization
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      return axios
        .get(apiUrl, config)
        .then((response) => {
          this.ListaTurnos = response.data.records;

          this.loading = false; // Desactivar animación de carga
        })
        .catch(() => {
          // console.error('Error al obtener datos de la API', error);
          this.loading = false; // Desactivar animación de carga en caso de error
        });
    },
    exportToExcel() {
      const wb = XLSXUtils.book_new();
      const ws = XLSXUtils.json_to_sheet(this.ListaTurnos);
      XLSXUtils.book_append_sheet(wb, ws, "Turnos");

      writeExcel(wb, "Turnos.xlsx");
    },
  },
};
</script>
